unit UTaetList;

interface

uses
  System.Contnrs, UTaetModel, Js, UEssentialHelper;

type
  TTaetList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    FOnError: TErrorEvent;
    function GetItem(i: Integer): TTaetModel;
    procedure DoError(AMsg: string);
    procedure PropertyChanged;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetValues(json: string); overload;
    procedure SetOnPropertyChanged(const Value: TCallback);
    procedure SetOnError(const Value: TErrorEvent);
  public
    constructor Create;
    function IndexOf(Value: string): Integer;
    procedure Add(item: TTaetModel);
    procedure GetAll(url: string; fakId: Integer; searchString: string);
    property Items[i: Integer]: TTaetModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
    property OnError: TErrorEvent read FOnError write SetOnError;
  end;

implementation

uses
  System.SysUtils, WebLib.REST, WebLib.json, WebLib.Controls, WebLib.Storage;

{ TTaetList }

procedure TTaetList.Add(item: TTaetModel);
begin
  inherited Add(item);
end;

constructor TTaetList.Create;
begin
  inherited Create;
  Self.OnPropertyChanged := nil;
  Self.OnError := nil;
end;

procedure TTaetList.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TTaetList.GetAll(url: string; fakId: Integer; searchString: string);
var
  client: TRestClient;
  obj: TJsonObject;
  s, cmd: string;
  procedure Response(sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    if aResponse <> '' then
      TLocalStorage.SetValue(cmd, aResponse)
    else
      aResponse := TLocalStorage.GetValue(cmd);
    if aResponse <> '' then
    begin
      jso := TJsJson.parseObject(aResponse);
      if jso['value'] <> nil then
        Self.SetValues(string(jso['value']));
      Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TTaetList.GetAll');
  end;

  procedure ErrorHandler(sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Self, '');
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('FakId', IntToStr(fakId));
  obj.AddPair('SearchString', searchString);
  s := obj.ToString;
  cmd := url + '/TaetService/GetAll_' + s;
  obj := TJsonObject.Create;
  obj.AddPair('value', s);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  client.HttpsPost(url + '/TaetService/GetAll', 'application/json',
    obj.ToString);
end;

function TTaetList.GetItem(i: Integer): TTaetModel;
begin
  Result := inherited GetItem(i) as TTaetModel;
end;

function TTaetList.IndexOf(Value: string): Integer;
var
  i: Integer;
  found: Boolean;
begin
  found := false;
  i := 0;
  while not found and (i < Self.Count) do
    if Self.Items[i].Bezeichnung = Value then
      found := true
    else
      Inc(i);
  if found then
    Result := i
  else
    Result := -1;
end;

procedure TTaetList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TTaetList.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TTaetList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TTaetList.SetValues(json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

procedure TTaetList.SetValues(obj: TJsObject);
var
  i, Count: Integer;
begin
  Self.Clear;
  if obj['Count'] <> nil then
  begin
    Count := StrToInt(string(obj['Count']));
    for i := 0 to Count - 1 do
      if obj['Item' + IntToStr(i)] <> nil then
        Self.Add(TTaetModel.Create(string(obj['Item' + IntToStr(i)])));
  end;
end;

end.
